import { Evidence } from '@/api/holeInOneClaim/evidence.types.ts';
import { MediaFile } from '@/api/shared.types.ts';

export const evidenceToMediaFile = (evidence: Evidence): MediaFile => {
  return {
    id: evidence.id,
    url: evidence.fetchUrl,
    type: evidence.fileType,
    name: evidence.type === 'certificate' ? 'Certificate' : 'Captured moment',
  };
};
